$(document).ready(function () {
  setTimeout(() => {
    const sris = [];
    const handles = [];
    let hidden = 0;

    $('#search-results-title').addClass('hide');
    $('.search-result-item .result-price').addClass('hide');
    $('.search-result-item').map((sr) => {
      const el = $('.search-result-item')[sr];
      $(el).addClass('hide');
      sris.push(el);
    });

    $('.search-result-item .description-item:first-child span.value').map((span) => {
      handles.push($($('.search-result-item .description-item:first-child span.value')[span]).text());
    });

    handles.map((handle, i) => {
      let prodHandle = handle;
      let hide = false;
      let dcp = window.current_customer.custom_products;
      let cpp = window.current_customer.custom_product_prefixes || null;
      let defPrefix = {};
      if (cpp) {
        cpp.split(',').map((pr) => {
          defPrefix[pr] = true;
        });
        if (dcp != null) {
          let cp = dcp.split(',');
          if (cp.length > 0) {
            let prefixes = [];
            cp.map((prods) => {
              if (prods != null && prods != 'null' && prods.length > 0) {
                let pre = prods.substring(0, 3);
                if (
                  typeof defPrefix[pre] != 'undefined' &&
                  (prodHandle.indexOf(cpp.split(',')[0]) == 0 || prodHandle.indexOf(cpp.split(',')[1]) == 0)
                ) {
                  prefixes.push(pre);
                  if (dcp.indexOf(prodHandle) == -1) {
                    $(sris[i]).addClass('hide');
                    hide = true;
                    hidden += 1;
                  }
                }
              } else if (defPrefix[prodHandle.substring(0, 3)]) {
                hide = true;
                hidden += 1;
                $(sris[i]).addClass('hide');
              }
            });
          }
        }
      }

      if (!hide) {
        $(sris[i]).removeClass('hide');
      }
    });

    if (hidden == handles.length || handles.length == 0) {
      $('#search-results-title').html('No results found.');
    } else {
      const count = handles.length - hidden;
      const title = $('#search-results-title')
        .text()
        .trim()
        .replace($('#search-results-title').text().trim().split(' ')[0], count > 0 ? count : 0);
      document.title = `Search results: ${title}`;
      $('#search-results-title').text(title);
    }

    $('#search-results-title').removeClass('hide');
    $('#search-results').removeClass('hide');
  }, 500);
});
